export default "__VITE_ASSET__a627209e__"